if (!customElements.get('search-overlay')) {
  customElements.define(
    'search-overlay',
    class SearchOverlay extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('input[type="search"]');
        this.addEventListener('keydown', this.onKeydown.bind(this));
        this.querySelectorAll('[data-search-overlay-close]').forEach((button) =>
          button.addEventListener('click', this.close.bind(this))
        );
      }

      onKeydown(event) {
        if (event.code === 'Escape') this.close();
      }

      open(trigger) {
        this.trigger = trigger;
        this.setAttribute('open', '');
        document.body.classList.add('overflow-hidden');
        // Fokus synchronně v rámci tap gesta — iOS pak spolehlivě otevře klávesnici
        trapFocus(this, this.input);
      }

      close() {
        if (!this.hasAttribute('open')) return;
        this.removeAttribute('open');
        document.body.classList.remove('overflow-hidden');
        const returnFocusTo = this.trigger && this.trigger.isConnected ? this.trigger : undefined;
        removeTrapFocus(returnFocusTo);
        this.trigger = null;
      }
    }
  );

  // Delegace na document — trigger v hlavičce přežije přerenderování sekce v editoru
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-search-overlay-trigger]');
    if (!trigger) return;
    document.getElementById('Search-Overlay')?.open(trigger);
  });
}
